import React from "react";
import SelectStandard from "./SelectStandard";
import Text from "./Text";
import GridItem from "./GridItem";
import Box from "./Box";

function SelectRow({ fields, explaination, handleChange }) {
  return (
    <>
      {explaination && <Text>{explaination}</Text>}
      <Box display={[null, null, "flex", null]} mt="40px">
        {fields.map((field, index) => {
          const firstOfKind = index === 0;
          return (
            <Box
              key={field.name}
              mr={firstOfKind && [0, 0, "15px", null]}
              mb={firstOfKind && ["15px", null, 0, null]}
            >
              <SelectStandard
                name={field.label}
                borderWidth="1px"
                value={field.value}
                options={field.options}
                handleChange={(value) => {
                  handleChange({
                    [field.name]: {
                      value: value,
                    },
                  });
                }}
                invertOnMobile={false}
              />
            </Box>
          );
        })}
      </Box>
    </>
  );
}

export default SelectRow;
